import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
import TextField from "@mui/material/TextField";
import InputBase from "@mui/material/InputBase";
import { useDispatch } from "react-redux";
import { updateSupervisor } from "../../store/UserMaintanence";
import { Close } from "@mui/icons-material";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};
const ColorButton = styled(Button)(({ theme }) => ({
  borderRadius: "0px",
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}));

function EditSupervisor(props) {
  const dispatch = useDispatch();
  const [newUser, setNewUser] = useState("");
  const [newSuper, setNewSuper] = useState("");
  const [isUserNameNull, setIsUserNameNull] = useState(false);
  const [isSuperNameNull, setIsSuperNameNull] = useState(false);
  const [isAddUserOpen, setIsAddUserOpen] = useState(false);

  const handleClose = () => {
    props.setOpenEdit(false);
    setNewUser("");
    setNewSuper("");
    setIsAddUserOpen(false);
    // dispatch(getUserMaintanenceData());
  };
  //  function to save the qa's
  const saveAddHandle = () => {
    if (newSuper == "") {
      setIsUserNameNull(true);
      setIsAddUserOpen(true);
      // dispatch(getUserMaintanenceData());
    }
    if (newSuper != "") {
      console.log(newSuper + " neww Userr " + props.entId);
      //   dispatch(addUser(newUser, newSuper));
      dispatch(updateSupervisor(newSuper, props.entId));
      props.setBoolChecked(true);
      setIsUserNameNull(false);
      setIsSuperNameNull(false);
      setNewUser("");
      setNewSuper("");
      props.setOpenEdit(false);
      setIsAddUserOpen(false);
    }
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.openEdit}
        PaperProps={{ sx: { width: "500px", maxWidth: "500px", borderTop: "2px solid #A100FF", borderRadius: "0px !important" } }}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          className="popup"
          sx={{
            padding: "10px 20px",
            fontSize: "18px",
            fontWeight: "500",
            color: "#000000",
            backgroundColor: "#F1F1EF"
          }}
          onClose={handleClose}
        >
          Edit Supervisor
        </BootstrapDialogTitle>
        <DialogContent sx={{ padding: "0px !important"}}>
          <Stack sx={{ padding: "10px 20px" }} spacing={2}>
            <Stack spacing={1}>
              <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#000000", marginBottom: "8px", }}>
                Current Supervisor ID <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                className="coursecode-textfield"
                size="small"
                fullWidth
                multiline
                value={props.supervisorRowId}
                disabled
                sx={{ width: "100%", fontSize: "14px !important", "& .MuiOutlinedInput-root.MuiOutlinedInput-root": {borderRadius: 0, height: 38 } }}
              />
              <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#000000", marginBottom: "8px", marginTop: "15px !important" }}>
                Enter New Supervisor ID <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                error={isSuperNameNull && isAddUserOpen ? true : false}
                required={isSuperNameNull && isAddUserOpen ? false : true}
                className="coursecode-textfield"
                size="small"
                fullWidth
                multiline
                id={
                  isSuperNameNull && isAddUserOpen
                    ? "outlined-error"
                    : "outlined-required"
                }
                variant="outlined"
                helperText={
                  isSuperNameNull && isAddUserOpen
                    ? "Please enter the supervisor name"
                    : null
                }
                onChange={(e) => {
                  setNewSuper(e.target.value);
                  if (newSuper !== "") {
                    setIsSuperNameNull(false);
                  }
                }}
                sx={{ width: "100%", fontSize: "14px !important", "& .MuiOutlinedInput-root.MuiOutlinedInput-root": {borderRadius: 0, height: 38 } }}
              />
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ padding: "10px 20px !important", backgroundColor: "#F1F1EF"}}>
          <ColorButton
            variant="contained"
            className="cancel-button"
            size="small"
            sx={{
              backgroundColor: "#F1F1EF",
              border: "1px solid #CFCFCF",
              padding: "5px 30px",
              color: "#000000",
              borderRadius: 0,
              height: "30px",
            }}
            onClick={handleClose}
          >
            Cancel
          </ColorButton>
          <ColorButton
            variant="contained"
            className="save-button"
            size="small"
            sx={{ backgroundColor: "#000000",
              border: "1px solid #000000",
              padding: "5px 30px",
              color: "#fff",
              borderRadius: 0,
              height: "30px",
              "&:hover": { backgroundColor: "#000000" }, }}
            onClick={saveAddHandle}
          >
            Submit
          </ColorButton>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}

export default EditSupervisor;
